module.exports = __webpack_public_path__ + "officialStatic/img/small1.9a19a79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/small1.png
// module id = plV1
// module chunks = 0